import { Routes } from '@angular/router';

import { DatacenterComponent } from '../shared/datacenter/datacenter.component';
import { SERVICE_ANALYTICS } from '../shared/models/list';
import { DatacenterViewCustomizationComponent }
	from '../shared/datacenter/view-customization/datacenter-view-customization.component';

import { AqdbBatchCardComponent } from './components/card/aqdb-batch-card.component';

export const routes: Routes = [
	{
		path: 'card/:batchid',
		component: AqdbBatchCardComponent,
		data: { pageName: 'Quality Data - Batch Card' }
	},
	{
		path: 'datacenter',
		children: [
			{
				path: '',
				component: DatacenterComponent,
				data: {
					pageName: 'Quality Data - Datacenter',
					service: SERVICE_ANALYTICS.AQDB,
					type: 'aqdb',
					title: 'datacenter.aqdb-view',
					exportExcelName: 'AQDB Quality Data'
				}
			},
			{
				path: 'view',
				component: DatacenterViewCustomizationComponent,
				data: { pageName: 'Quality Data - Datacenter Customization', service: SERVICE_ANALYTICS.AQDB }
			}
		]
	}
];
